module.exports = __webpack_public_path__ + "img/home-banner.faa2aad2.jpg";